(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.TailSpin = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TailSpin = undefined;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var TailSpin = exports.TailSpin = function TailSpin(svg) {
    return _react2.default.createElement("svg", {
      width: svg.width,
      height: svg.height,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg"
    }, _react2.default.createElement("defs", null, _react2.default.createElement("linearGradient", {
      x1: "8.042%",
      y1: "0%",
      x2: "65.682%",
      y2: "23.865%",
      id: "a"
    }, _react2.default.createElement("stop", {
      stopColor: svg.color,
      stopOpacity: "0",
      offset: "0%"
    }), _react2.default.createElement("stop", {
      stopColor: svg.color,
      stopOpacity: ".631",
      offset: "63.146%"
    }), _react2.default.createElement("stop", {
      stopColor: svg.color,
      offset: "100%"
    }))), _react2.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, _react2.default.createElement("g", {
      transform: "translate(1 1)"
    }, _react2.default.createElement("path", {
      d: "M36 18c0-9.94-8.06-18-18-18",
      id: "Oval-2",
      stroke: svg.color,
      strokeWidth: "2"
    }, _react2.default.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "0.9s",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      fill: "#fff",
      cx: "36",
      cy: "18",
      r: "1"
    }, _react2.default.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "0.9s",
      repeatCount: "indefinite"
    })))));
  };
});